import React from "react";
import "./JibuFeature.css";
import { FaComments, FaRobot, FaChartPie, FaCogs, FaUsers, FaShieldAlt } from "react-icons/fa";

const features = [
  {
    icon: <FaComments />,
    title: "Omnichannel Messaging",
    description: "Connect with users on WhatsApp, Messenger, and web chat from one smart bot."
  },
  {
    icon: <FaRobot />,
    title: "AI Conversation Engine",
    description: "Understand and respond naturally using AI-driven logic and flow control."
  },
  {
    icon: <FaChartPie />,
    title: "Analytics Dashboard",
    description: "Track performance, engagement rates, and user behavior with visual reports."
  },
  {
    icon: <FaCogs />,
    title: "Workflow Automation",
    description: "Automate FAQs, lead capture, bookings, and more — with no code needed."
  },
  {
    icon: <FaUsers />,
    title: "User Segmentation",
    description: "Personalize messages for different user types, interests, or behaviors."
  },
  {
    icon: <FaShieldAlt />,
    title: "Secure & Compliant",
    description: "Built with data privacy and GDPR compliance at the core."
  }
];

const JibuFeature = ({ isDarkMode }) => {
  return (
    <section className={`jibu-feature-section ${isDarkMode ? "dark-mode" : "light-mode"}`}>
      <h2>What Can JibuBot Do?</h2>
      <p className="subtext">
        JibuBot is packed with powerful features to streamline conversations, boost engagement, and automate success.
      </p>

      {features.map((feature, index) => (
        <div className="feature-block" key={index}>
          <div className="icon">{feature.icon}</div>
          <h3>{feature.title}</h3>
          <p>{feature.description}</p>
        </div>
      ))}
    </section>
  );
};

export default JibuFeature;
